import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { TrackerService } from 'src/app/shared/util/tracker.service';
import { environment } from 'src/environments/environment';

interface ValuePillar {
  icon: string;
  titleKey: string;
  textKey: string;
}

interface Milestone {
  year: string;
  titleKey: string;
  textKey: string;
  future?: boolean;
}

@Component({
  selector: 'footer-about-us',
  templateUrl: './footer-about-us.component.html',
  styleUrls: ['./footer-about-us.component.scss']
})
export class FooterAboutUsComponent implements OnInit {
  assistantHref = environment.assistantApp || 'https://admin.propero.io';

  readonly valuePillars: ValuePillar[] = [
    { icon: 'lni-bolt', titleKey: 'ABOUT_US.VALUES.PILLAR1_TITLE', textKey: 'ABOUT_US.VALUES.PILLAR1_TEXT' },
    { icon: 'lni-shield', titleKey: 'ABOUT_US.VALUES.PILLAR2_TITLE', textKey: 'ABOUT_US.VALUES.PILLAR2_TEXT' },
    { icon: 'lni-users', titleKey: 'ABOUT_US.VALUES.PILLAR3_TITLE', textKey: 'ABOUT_US.VALUES.PILLAR3_TEXT' },
    { icon: 'lni-graph', titleKey: 'ABOUT_US.VALUES.PILLAR4_TITLE', textKey: 'ABOUT_US.VALUES.PILLAR4_TEXT' },
  ];

  readonly milestones: Milestone[] = [
    { year: '2021', titleKey: 'ABOUT_US.STORY.TIMELINE.2021.TITLE', textKey: 'ABOUT_US.STORY.TIMELINE.2021.DESCRIPTION' },
    { year: '2023', titleKey: 'ABOUT_US.STORY.TIMELINE.2023.TITLE', textKey: 'ABOUT_US.STORY.TIMELINE.2023.DESCRIPTION' },
    { year: '2026', titleKey: 'ABOUT_US.STORY.TIMELINE.2026.TITLE', textKey: 'ABOUT_US.STORY.TIMELINE.2026.DESCRIPTION' },
    { year: '2027', titleKey: 'ABOUT_US.STORY.TIMELINE.2027.TITLE', textKey: 'ABOUT_US.STORY.TIMELINE.2027.DESCRIPTION', future: true },
  ];

  constructor(
    public translate: TranslateService,
    private trackerService: TrackerService
  ) { }

  ngOnInit(): void {
    this.trackerService.trackPageViews();
    window.scrollTo(0, 0);
  }
}
